import {
  SelectContent,
  SelectField,
  SelectItem,
} from "@ps-design-system/components/Select";

import { useIntl } from "react-intl-compat";

const MIN_AGE_OPTIONS = Array.from({ length: 22 }, (_, age) => age)
  .slice(1)
  .sort((a, b) => b - a);

/** The "who's allowed" minimum-age select. */
const MinAgeField = () => {
  const intl = useIntl();

  return (
    <SelectField
      fullWidth
      name="minAge"
      label={intl.formatMessage({
        id: "hosting.listing_rules.min_age_label",
        defaultMessage: "Who's allowed in your space",
      })}
      testId="rules-form-min-age-select"
      renderContent={() => (
        <SelectContent>
          <SelectItem key="all-ages" value="0">
            {intl.formatMessage({
              id: "hosting.listing_rules.min_age_all_ages",
              defaultMessage: "All ages",
            })}
          </SelectItem>
          {MIN_AGE_OPTIONS.map((age) => (
            <SelectItem key={age} value={String(age)}>
              {age === 0
                ? intl.formatMessage({
                    id: "hosting.listing_rules.min_age_all_ages",
                    defaultMessage: "All ages",
                  })
                : intl.formatMessage(
                    {
                      id: "hosting.listing_rules.min_age_option",
                      defaultMessage: "Ages {age}+",
                    },
                    { age },
                  )}
            </SelectItem>
          ))}
        </SelectContent>
      )}
    />
  );
};

export { MinAgeField };
